module.exports = __webpack_public_path__ + "img/record_img_1.239167cd.png";